import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';

@Injectable({
	providedIn: 'root'
})
export class AutocompleteService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	getCustomers(term) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/ac/customers/` + encodeURIComponent(term));
	}

	getLocations(type, term, sessionId) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/ac/locations/` + encodeURIComponent(type) + `/` + encodeURIComponent(sessionId) + `/` + encodeURIComponent(term));
	}

	getVehicleModels(term) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/ac/vehiclemodels/` + encodeURIComponent(term));
	}
}
